import React, { useState } from 'react';
import { Plus, SquarePen, Trash2 } from 'lucide-react';
import * as api from '../api';
import { useHR } from '../../hr/HRContext';
import Modal from '../../hr/components/Modal';
import { Field, Panel, Sel, Tick, useLoad } from '../shared';
import Loader from '../../hr/components/Loader';

// Entry Types: the columns of the monthly sheets. DAYS / DEDUCTION / ADDITION are on Deductions & Adjustments; OUTSIDE PAY on Other Expenses.
export default function EntryTypes({ perms }) {
  const { notify, confirm } = useHR();
  const [d, setD, , error] = useLoad(api.entryTypes);
  const [t, setT] = useState(null);
  if (error) return <div className="error">{error}</div>;
  if (!d) return <Loader title="Loading entry types…" />;
  const ro = !perms.setup;
  return (
    <Panel title="Entry types" note="Set-up: changed directly by whoever holds Payroll Set-up. A type that has entries can only be set inactive."
           actions={!ro && <button className="btn primary small" onClick={() => setT({ name: '', kind: 'DEDUCTION', taxable: true, is_active: true })}><Plus size={13} /> Add type</button>}>
      <div className="table-wrap"><table><thead><tr><th>Code</th><th>Name</th><th>Kind</th><th>Sheet</th><th>Taxable</th><th>Active</th><th className="num">Entries</th><th /></tr></thead>
        <tbody>{d.types.map(x => (
          <tr key={x.id}><td className="mono small">{x.code}</td><td><b>{x.name}</b></td><td>{x.kind}</td><td className="small">{x.sheet}</td>
            <td>{x.kind === 'ADDITION' ? <Tick v={x.taxable} /> : <span className="muted">—</span>}</td><td><Tick v={x.is_active} /></td><td className="num">{x.used}</td>
            <td className="nowrap">{!ro && <>
              <button className="btn small" onClick={() => setT({ ...x })}><SquarePen size={12} /></button>{' '}
              <button className="btn small danger ghost" disabled={!!x.used} title={x.used ? 'Has entries — set inactive instead' : 'Delete'} onClick={async () => {
                if (await confirm({ title: 'Delete entry type', message: `Delete ${x.name}?`, confirmLabel: 'Delete', danger: true })) {
                  try { setD(await api.deleteEntryType(x.id)); notify('Deleted.'); } catch (e) { notify(e.message, 'bad'); }
                }
              }}><Trash2 size={12} /></button></>}</td></tr>))}
        </tbody></table></div>
      {t && <TypeModal t={t} kinds={d.kinds} notify={notify} onClose={() => setT(null)} onSaved={r => { setD(r); setT(null); notify('Saved.'); }} />}
    </Panel>
  );
}

function TypeModal({ t, kinds, notify, onClose, onSaved }) {
  const [f, setF] = useState(t);
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const save = async () => { try { onSaved(await api.saveEntryType(f.id, f)); } catch (e) { notify(e.message, 'bad'); } };
  return (
    <Modal title={f.id ? `Edit ${t.name}` : 'Add entry type'} onClose={onClose} footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn primary" onClick={save}>Save</button></>}>
      <div className="form-grid">
        <Field label="Name"><input value={f.name} maxLength={80} onChange={e => set('name', e.target.value)} /></Field>
        <Field label="Kind"><Sel value={f.kind} onChange={v => set('kind', v)} options={kinds} /></Field>
        {f.kind === 'ADDITION' && <Field label="Taxable"><Sel value={f.taxable ? 'Yes' : 'No'} onChange={v => set('taxable', v === 'Yes')} options={['Yes', 'No']} /></Field>}
        <Field label="Active"><Sel value={f.is_active ? 'Yes' : 'No'} onChange={v => set('is_active', v === 'Yes')} options={['Yes', 'No']} /></Field>
      </div>
    </Modal>
  );
}
